import * as css from './Event.css';
import {useEffect,  useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {changeAccountMessage} from '../../userPackages/UserPackages';
import EventOption from './eventOption/EventOption';
import {tsGetYear, tsToDate} from '../../../library/dates';
import {defaultImage} from '../../../assets/symbols/images/defaultImage';
import StaticActiveInactive from '../../../component/staticActiveInactive/StaticActiveInactive';
import Tooltip from '../../../component/tooltip/Tooltip';
import {reloadIframe} from '../../myIframe/MyIframe';
import {useSelector} from 'react-redux';
import {eventDuplication} from '../../../redux/event/eventActions';
import TickchakLoader from '../../../component/tickchakLoader/TickchakLoader';
import getCountryByTimeZone from '../../../library/getCountryByTimeZone';
import useGlobalShow from '../../../hooks/useGlobalShow';

function Event ({event,className,onEventClick}) {
    const [show, setShow] = useState(0);
    const paletteClass=(event.type==='course'&&[3,4].includes(event.ready))&&'palette';
    const {t} = useTranslation('layout');
    const accountT=useTranslation('package');
    const navigate = useNavigate();
    const currentEid=useSelector(s=>s.event.eid);
    const duplicateXHR = useSelector(s=>s.event.eventDuplicationXHR);
    const {close}=useGlobalShow('isOpenEvents');
    useEffect(() => {
        const timeout = setTimeout(function () {
            setShow(1);
        }, 0);
        return () => clearTimeout(timeout);
    }, []);
    const callBackDuplicateEvent=(newEvent)=>{
        navigate(`/e/${newEvent?.newEvent?.eid}/event`);
    };
    const duplicateEvent = () =>{
        const ready = event.type === 'area' ? 1 : 0;
        let updatedEvent = {...event, ready, title: event.title+' '+t('copy'),  timeOpen:null, timeStart:null,timeEnd:null};
        eventDuplication(event.eid,updatedEvent, callBackDuplicateEvent);
    };

    const isCurrentEvent=currentEid===event.eid;
    const linkClick=()=>{
        if(onEventClick) {
            onEventClick();
        }
        if(isCurrentEvent){
            reloadIframe();
            close();
        }
        else {
            changeAccountMessage(event,accountT,navigate);
        }
    };
    return (
        <>
            <Link  to={`/e/${event.eid}/realtime`}  onClick={linkClick} data-cy={`event-link-${event.eid}`} style={{display:'block', width:'calc(100% - 40px)', margin:'10px auto'}}>
                <css.Event  className={'event ' + (show && 'show') + ' ' + className} status={(event.tickets.sold * 100) / event.tickets.amount} data-cy="eventItem" >
                    <css.EventContent className="eventContent" >
                        <css.EventContentMain className={'eventContentMain '+ paletteClass} >
                            <css.ECMainData>
                                <css.ECMainTitle className={'eCMainTitle ' +paletteClass }>{event.title}</css.ECMainTitle>
                                <css.ECMainDate className="eCMainDate" >
                                    {event.type==='course'?
                                        tsGetYear(event.timeStart)
                                        :(event.timeStart?
                                            `${tsToDate(event.timeStart,'',event.timeZone)} ${tsToDate(event.timeStart,'',event.timeZone,'HH:mm')} ${getCountryByTimeZone(event.timeZone)}`
                                            :t('continuousEvent'))}
                                </css.ECMainDate>
                            </css.ECMainData>
                            <css.ECMainOptions>
                                <EventOption event={event} openDuplicateEvent={duplicateEvent}/>
                            </css.ECMainOptions>
                        </css.EventContentMain>
                        <css.EventContentBot>
                            <css.EventStateBtn>
                                <Tooltip text={t(event.active?'activeMode':'inActiveMode')}>
                                    <StaticActiveInactive isActive={event.active}/>
                                </Tooltip>
                            </css.EventStateBtn>
                            <css.EventContentPack className="eventContentBot">{event.pTitle}</css.EventContentPack>
                        </css.EventContentBot>
                    </css.EventContent>
                    <css.EventImg className="eventImg" image={event.fbImg||defaultImage}>
                        <css.EventImgOption className="eventImgOption"/>
                        <css.EventImgEdit className="eventImgEdit" />
                    </css.EventImg>
                </css.Event>
            </Link>
            {duplicateXHR==='LOADING' && <TickchakLoader/>}
        </>

    );
}

export default Event;
